// React
import React from 'react';
// External
import { Breadcrumb } from 'react-bootstrap';
import { Check2 } from 'react-bootstrap-icons';
import { withRouter } from 'react-router-dom';
// Styles
import './styles.scss';

/**
 * @param {Object} props.className - Class to be applied to the button
 * @param {Function} props.steps - On click function handler
 */
class Stepper extends React.Component {
    constructor(props) {
        super(props);
        this.className = props.className ? props.className : '';
        this.state = {
            steps: props.steps ? props.steps : []
        };
    }

    componentDidMount() {
        // Sets the initial status of the steps bases on the hash
        this.setStepStatus(this.props.steps);
    }

    componentDidUpdate(prevProps) {
        // Only when the hash changes the status update will be triggered
        if (prevProps.location.hash !== this.props.location.hash) {
            this.setStepStatus(this.state.steps);
            // Updates the path to clear the search
            this.props.history.push(this.props.location.pathname + this.props.location.hash);
        } else if (this.props.activeStep && prevProps.activeStep !== this.props.activeStep) {
            this.setStepStatus(this.state.steps);
        } else if (this.props.steps !== prevProps.steps) {
            this.setStepStatus(this.props.steps);
        }
    }

    setStepStatus = (steps) => {
        let isDone = !!(this.props.location.hash || this.props.activeStep);
        steps.forEach((step) => {
            // If hasn't been worked it is displayed as disabled or white
            if ((this.props.location.hash && this.props.location.hash === step.hash)
                || (this.props.activeStep && this.props.activeStep === step.name)) {
                step.status = 'active';
                isDone = false;
            } else if (isDone) {
                // If has already been done it displays a check icon
                step.status = 'done';
            } else {
                // If hasn't been worked it is displayed as disabled or white
                step.status = 'disabled';
            }
        });
        this.setState({
            steps
        });
    }

    render() {
        return (
            <Breadcrumb className="custom-breadcrumb">
                {this.state.steps.map((step, index) => (
                    <Breadcrumb.Item
                        key={step.hash}
                        className={step.status}
                        href={step.hash}
                        active={step.status === 'active'}
                        style={{ zIndex: step.status !== 'active' ? this.state.steps.length - index : '100' }}
                    >
                        <span>{step.label}</span>
                        {
                            step.status === 'done'
                                ? <Check2 size="18" color="#22D1B2" />
                                : null
                        }
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        );
    }
}

export default withRouter(Stepper);
